import { Pipe, PipeTransform } from '@angular/core';
import { ModalSize } from '@shared/modal/models/modal.size';

@Pipe({
    name: 'modalSize',
    standalone: false
})
export class ModalSizePipe implements PipeTransform {

	transform(value: ModalSize): string {
		switch (value) {
			case 'big':
				return 'w-2/3';
			case 'full':
				return 'w-full';
			case 'middle':
				return 'w-1/2';
			case 'small':
				return 'w-1/3';
			default:
				return 'w-2/3';
		}
	}

}
